<template>
    <div>
        <div ref="emptyPreviewsContainer" class="d-none"></div>
        <div ref="emptyDropzoneContainer" class="d-none"></div>
        <b-row class="flex-grow-1">
            <upload-item v-for="file in files" :file="file" @remove="removeFile(file)"/>

            <b-col @click="dropzoneClick"
                   v-if="files.length < 3"
                   class="d-flex align-items-stretch">
                <div class="uploader-action">
                    Drop your files here or <span class="text-primary ml-1">upload</span>
                </div>
            </b-col>
        </b-row>
    </div>

</template>

<script>
  import Dropzone from 'dropzone'
  import UploadItem from './OnboardingUploadItem'
  import FileObject from '../../../models/FileObject'
  import generalMixins from '../../../mixins/GeneralMixins'

  export default {

    props: ['url', 'initialFiles', 'maxFiles', 'paramName', 'dropArea', 'acceptedFiles'],

    data: function () {
      return {
        files: [],
        settingUpInitialFiles: false
      }
    },

    components: {UploadItem},

    mixins: [generalMixins],

    methods: {
      dropzoneClick: function () {
        this.dropzone.hiddenFileInput.click()
      },

      removeFile: function (fileObject) {
        if (fileObject.id) {
          this.$http.delete(`${this.url}/${fileObject.id}`).then(response => {
            this.dropzone.removeFile(fileObject._file)
          }, response => {
            fileObject.removing = false;
            this.showErrorToast("There was an error removing the file. Please try again later")
          })
        } else {
          this.dropzone.removeFile(fileObject._file)
        }
      },

      setupExistingFiles: function () {
        this.settingUpInitialFiles = true;
        this.initialFiles.forEach(file => {
          this.dropzone.emit("addedfile", file);
          this.dropzone.emit("thumbnail", file, file.asset_url);
          this.dropzone.emit("complete", file);
        });
        this.settingUpInitialFiles = false
      },

      findFileObject: function (file) {
        return this.files.find(f => file === f._file)
      },

      filesInclude: function (file) {
        let ff = this.findFileObject(file);
        return ff instanceof File
      }
    },

    mounted: function () {
      this.dropzone = new Dropzone(document.querySelector(this.dropArea), {
        url: this.url,
        headers: {'X-CSRF-Token': this.csrfToken},
        previewsContainer: this.$refs.emptyPreviewsContainer,
        clickable: this.$refs.emptyDropzoneContainer,
        paramName: this.paramName,
        previewTemplate: '<div></div>',
        thumbnailWidth: 300,
        thumbnailHeight: null,
        maxThumbnailFilesize: 20,
        maxFiles: this.maxFiles,
        acceptedFiles: this.acceptedFiles
      });

      this.dropzone.on('addedfile', file => {
        if (!this.settingUpInitialFiles && this.maxFiles && this.maxFiles <= this.files.length) {
          this.showErrorToast(`You can only add a maximum of ${this.maxFiles} files`);
          this.dropzone.removeFile(file)
        } else {
          const isValidFile = this.settingUpInitialFiles || Dropzone.isValidFile(file, this.dropzone.options.acceptedFiles)
          if (isValidFile && !this.filesInclude(file)) {
            this.files.push(new FileObject(file))
          } else {
            this.showErrorToast(`This file has an invalid format: ${file.name}`);
          }
        }
      });

      this.dropzone.on('thumbnail', (file, dataUrl) => {
        let fileObject = this.findFileObject(file);
        if (fileObject && !fileObject.asset_url) {
          fileObject.asset_url = dataUrl
        }
      });

      this.dropzone.on('removedfile', (file) => {
        let fileObject = this.findFileObject(file);
        if (fileObject) {
          this.files.splice(this.files.indexOf(fileObject), 1);
        }
      });

      this.dropzone.on('success', (file, xhr) => {
        let fileObject = this.findFileObject(file);
        if (fileObject) {
          // Upload finished and we got a server object id
          fileObject.id = xhr.id
        }
      });

      this.dropzone.on('uploadprogress', (file, progress, bytesSent) => {
        let fileObject = this.findFileObject(file)
        if (fileObject) {
          fileObject.progress = progress;
        }
      });

      this.dropzone.on('error', (file, errorMessage, xhr) => {
        let fileObject = this.findFileObject(file);
        if (fileObject) {
          fileObject.error = errorMessage;
          this.showErrorToast("There was an error uploading this file. Please try again later")
        }
      });

      this.setupExistingFiles()
    }
  }
</script>
